import { render, staticRenderFns } from "./user-forgotten.component.vue?vue&type=template&id=2a8378f2&"
import script from "./user-forgotten.component.ts?vue&type=script&lang=ts&"
export * from "./user-forgotten.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-forgotten.component.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VBtn,VCard,VForm})
